const BASE = ['type_classification'];

export const TYPE_CLASSIFICATION_QUERY_KEYS = {
  getTypeClassifications: () => [...BASE] as const,
};
